//src/layouts/auth/ResetPassword.js
import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../../services/authService";

export default function ResetPassword() {
    // 📌 Lấy query params từ URL (ví dụ: /reset-password?token=abc123)
    const [searchParams] = useSearchParams();

    // Lấy giá trị token từ query string
    const token = searchParams.get("token");

    // 📌 Dùng để điều hướng sang trang khác sau khi đổi mật khẩu thành công
    const navigate = useNavigate();

    // 📌 State lưu mật khẩu mới và xác nhận mật khẩu
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    // 📌 State lưu thông báo lỗi hoặc thành công
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    // ✅ State kiểm soát nút submit
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 📌 Xử lý khi người dùng submit form
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");

        if (password !== confirmPassword) {
            setError("Mật khẩu nhập lại không khớp");
            return;
        }
        setIsSubmitting(true); // Bắt đầu submit

        try {
            // 🔹 Gọi API reset mật khẩu
            const res = await resetPassword(token, password);
            // Lưu thông báo trả về từ server
            setMessage(res.message);

            // 🔹 Sau 2 giây sẽ điều hướng về trang đăng nhập
            setTimeout(() => {
                navigate("/login");
            }, 2000);
        } catch (err) {
            // 🔹 Nếu có lỗi từ server thì lấy message, nếu không thì dùng thông báo mặc định
            setError(err.response?.data?.message || "Có lỗi xảy ra");
        } finally {
            setIsSubmitting(false); // Kết thúc submit
        }
    };

    return (
        <div className="max-w-md mx-auto p-4">
            <h2 className="text-2xl font-bold mb-4">Đặt lại mật khẩu</h2>
            {message && <div className="text-green-500">{message}</div>}
            {error && <div className="text-red-500">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
                <input
                    type="password"
                    placeholder="Mật khẩu mới"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="w-full p-2 border rounded"
                />
                <input
                    type="password"
                    placeholder="Nhập lại mật khẩu mới"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    className="w-full p-2 border rounded"
                />
                <button
                    type="submit"
                    disabled={isSubmitting} // Disable khi submit
                    className={`w-full py-2 rounded text-white 
                        ${isSubmitting ? "bg-green-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"}`}
                >
                    {isSubmitting ? "Đang cập nhật mật khẩu..." : "Cập nhật mật khẩu"}
                </button>
            </form>
        </div>
    );
}
